<template>
  <div class="grid-content-Int">
    <v-row no-gutters class="mb-2">
      <!--10px-->
      <v-col cols="12" lg="3" md="3" class="pl-0 pt-0 pb-0">
        <!-- Tite-Message-Struture Left-->
        <v-row class="ma-0">
          <v-col cols="12" class="int-info-col">
            <v-toolbar-title class="int-info">{{$t('lbl.integrationSET.messageStructure')}}</v-toolbar-title>
          </v-col>
        </v-row>

        <!-- Message-Struture Left-->
        <v-row class="tree-panel edi-wrap-content-left ma-0">
          <v-col cols="12" class="text-left pa-0">
            <v-btn
              @click="expandAllTreeView"
              class="expand-all-tree-view-button"
              x-small
              tile
              dark
            >{{!expandAll ? 'Expand All' : 'Collapse All'}}</v-btn>
          </v-col>
          <v-col cols="12" class="col-tree">
            <!-- Treeview-Message-Struture -->
            <v-row class="no-gutters">
              <v-treeview
                ref="analyzedTreeView"
                :items="items"
                @update:open="readFileContent($event)"
                class="analyzedTree"
                activatable
                return-object
                rounded
                open-all
                open-on-click
              >
                <template v-slot:label="{ item}">
                  <div v-if="typeof item.children != 'undefined'" class="group-has-children-item">
                    <v-icon
                      :color="$vuetify.theme.dark ? '#F1DD2C' : '#498205'"
                      class="mr-1"
                      small
                    >fa fa-object-group</v-icon>
                    <span class="group-name">
                      <font :color="$vuetify.theme.dark ? '#F1DD2C' : '#498205'">{{item.name}}</font>
                    </span>
                    - {{item.useage}} - {{item.loop_max}} - {{item.description}}
                  </div>
                  <div
                    v-if="typeof item.children == 'undefined' && !item.disabled"
                    @click="itemClick(item)"
                    class="child-visible-item"
                  >
                    <v-icon
                      :color="$vuetify.theme.dark ? '#FFA6DB' : '#BA0070'"
                      class="mr-1"
                      small
                    >fa fa-cube</v-icon>
                    <span class="child-item">
                      <font :color="$vuetify.theme.dark ? '#FFA6DB' : '#BA0070'">{{item.name}}</font>
                    </span>
                    - {{item.useage}} - {{item.group_max}} - {{item.description}}
                  </div>
                </template>
              </v-treeview>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- Item-Details Right-->
      <v-col cols="12" lg="9" md="9" class="pr-0 pt-0 pb-0 grid-data-padding">
        <setSample :items="items2" :tmpId="tmpId" :clicked="clicked"></setSample>
      </v-col>
    </v-row>

    <!-- Button-Bottom -->
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col pa-0" lg="12">
        <div class="text-right">
          <v-btn class="btn btn-excel" @click="exportExcel">
            <i
              aria-hidden="true"
              class="v-icon notranslate mr-2 fa fa-file-excel theme--light"
              style="font-size: 12px;"
            ></i>
            {{$t('btn.integrationSET.downExcel')}}
          </v-btn>
          <v-btn class="btn btn-excel mr-0" @click="exportFile">
            <i
              aria-hidden="true"
              class="v-icon notranslate mr-2 fa fa-download theme--light"
              style="font-size: 12px;"
            ></i>
            {{$t('btn.integrationSET.sampleData')}}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import setSample from '@/vue-caas/views/integrationset/IntegrationSetSample.vue'
import { saveAs } from 'file-saver';
import $ from "jquery";
// Require library
var XLSX = require('xlsx');
var FileSaver = require('file-saver');

export default {

  components: {
    setSample
  },
  props: {
    items: {
      default : Array,
    },
    items2: {
      default : Array,
    },
    tmpId: {
      default : ''
    },
    tmpName:{
      default : '',
    },
  },

  data(){
    return{
    excelData: Array,
    listDatas: [],
    expandAll: false,
    tmpId2: '',
    clicked: {},
    sample_data: '',
    excel_data: []
  }},

  watch: {
    items() {
      return this.items;
    },
  },

  methods: {
    exportFile() {
      this.$store.dispatch('getSampleFile', {tmpId: this.tmpId, message_id: this.items2[0].BIZ_MSGID, version: this.items2[0].VERSION}).then(() => {
        this.sample_data = this.$store.getters.integrationSetSample;
        var file = new File([JSON.stringify(this.sample_data, null, 4)], this.tmpId+".json", {type: "json"});
        saveAs(file);
      }).catch((err) => {
        alert(err);
      });

    },
    async exportExcel(){
     Store.dispatch("getIntegrationSetExcelData", this.tmpId).then(() => {
      console.log("--------- Finished to process ----------");
      this.excel_data = this.$store.getters.integrationSetExcelData;
      let fileName = "IntegrationSet_Spec.xlsx"
      fileName = decodeURI(fileName);
      if (window.navigator.msSaveOrOpenBlob) { // IE 10+
        window.navigator.msSaveOrOpenBlob(this.excel_data, fileName);
      } else { // not IE
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(this.excel_data);
        link.target = '_self';
        if (fileName) link.download = fileName;
        link.click();
        }
      });
    },

    itemClick(item) {
      this.clicked = item
    },
    expandAllTreeView() {
      this.expandAll = !this.expandAll;
      if (this.expandAll) {
        this.treeItems = this.items;
        this.$refs.analyzedTreeView.updateAll(this.expandAll);
      } else {
        this.$set(this, 'items', []);
        this.$nextTick(() => {
          this.$set(this, 'items', this.treeItems);
        });
      }
    },

    readFileContent(event){
      if (event !== undefined && event.length > 0) {
        this.tmpId2 = event[event.length-1].id;
        //this.tmpName = event[event.length-1].name;
      }

      if(this.tmpId2 != '') {
        this.$store.dispatch('getReadFileContent', this.tmpId2).then(() => {
          this.listDatas = this.$store.getters.integrationSetContent;
          //this.selectedComp = 'setSample';
        }).catch((err) => {
          alert(err);
          //this.selectedComp = 'setSample';
        });
      }
    },
  },

  created() {
    this.readFileContent();
  },
}
</script>

<style>
</style>